module.exports = __webpack_public_path__ + "img/fruit-circled.22d2b83a.svg";